var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification is-danger m-3"},[_c('button',{staticClass:"delete",on:{"click":_vm.clear}}),_vm._v(" "+_vm._s(_vm.messages[0])+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }